import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export default ({ show, message, onYes, onNo, onClose }) => {
  return (
    <Modal id='confirmPopup' show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onNo}>
          No
        </Button>
        <Button variant='primary' onClick={onYes}>
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
